var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPlayMusicWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2284_11520)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2284_11520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0C7.83515 0 0 7.83501 0 17.5C0 27.165 7.83515 35 17.5 35C27.1649 35 35 27.165 35 17.5C35 7.83501 27.1649 0 17.5 0ZM23.5484 18.4276L14.7984 23.8964C14.6214 24.0069 14.4201 24.0625 14.2188 24.0625C14.0364 24.0625 13.8537 24.0171 13.6884 23.9252C13.3407 23.7325 13.125 23.3666 13.125 22.9688V12.0312C13.125 11.6334 13.3407 11.2675 13.6884 11.0748C14.0361 10.8809 14.4612 10.8927 14.7984 11.1036L23.5484 16.5724C23.8681 16.7727 24.0625 17.123 24.0625 17.5C24.0625 17.877 23.8681 18.2274 23.5484 18.4276Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2284_11520",
    x: -3,
    y: -3,
    width: 41,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2284_11520"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2284_11520",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayMusicWhiteIcon);
export default __webpack_public_path__ + "static/media/videoPlayMusicWhiteIcon.81aebac42199cfb999bf90bc1e507a90.svg";
export { ForwardRef as ReactComponent };